import { ChangeEvent } from "react";
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo";
import { DCUIContent, DCUIContentStart } from "@iddataweb/idw-common-ui/types";
import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { DCUIThemingStartPageValidationErrors } from "@idw-types/common/validation/common/dcui-theming-validation-errors";
import { InputFormGroup } from "../../../../../common/input-form-group/input-form-group";
import { ThemingFormGroupWrapper } from "@containers/common/theming-input-form-group/theming-form-group-wrapper";
import { PageLevelTypes } from "@enums/page-level-types";

type DCUIThemingStartPageButtonsSectionProps = {
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    isDisabled: boolean;
    dcuiContent: DCUIContent;
    inheritedDCUIContent: DCUIContent;
    pageLevel: PageLevelTypes;
    validationErrors: DCUIThemingStartPageValidationErrors;
    updateDCUIContentStartPageFieldValue: (key: keyof DCUIContentStart, value: string) => void;
};

export const DCUIThemingStartPageButtonsSection = (props: DCUIThemingStartPageButtonsSectionProps) => {
    const {
        layout,
        labelWidth,
        isDisabled,
        dcuiContent,
        inheritedDCUIContent,
        pageLevel,
        validationErrors,
        updateDCUIContentStartPageFieldValue
    } = props;

    const handleStartButtonTextChange = async (event: ChangeEvent<HTMLInputElement>) => {
        updateDCUIContentStartPageFieldValue("buttonText", event.target.value);
    };

    const handleResetStartButtonText = () => {
        updateDCUIContentStartPageFieldValue("buttonText", inheritedDCUIContent.start.buttonText);
    };

    const handleStartButtonLoadingTextChange = async (event: ChangeEvent<HTMLInputElement>) => {
        updateDCUIContentStartPageFieldValue("loadingButtonText", event.target.value);
    };

    const handleResetStartButtonLoadingText = () => {
        updateDCUIContentStartPageFieldValue("loadingButtonText", inheritedDCUIContent.start.loadingButtonText);
    };

    return (
        <div>
            <ThemingFormGroupWrapper
                inheritedThemingPropertyValue={inheritedDCUIContent.start.buttonText}
                currentThemingPropertyValue={dcuiContent.start.buttonText}
                pageLevel={pageLevel}
            >
                <InputFormGroup
                    controlId={"dcui-theming-start-page-start-button-text-input"}
                    automationId={"dcui-theming-start-page-start-button-text-input"}
                    label={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.startPage.sections.buttons.inputs.startButtonText.label}
                    ariaLabel={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.startPage.sections.buttons.inputs.startButtonText.label}
                    layout={layout}
                    labelWidth={labelWidth}
                    onChange={handleStartButtonTextChange}
                    value={dcuiContent.start.buttonText || ""}
                    disabled={isDisabled}
                    isRequired={true}
                    afterLabelTooltipText={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.startPage.sections.buttons.inputs.startButtonText.tooltip}
                    afterLabelIcon={isDisabled ? null : faUndo}
                    afterLabelIconOnClick={handleResetStartButtonText}
                />
            </ThemingFormGroupWrapper>

            {validationErrors.startButtonTextError}

            <ThemingFormGroupWrapper
                inheritedThemingPropertyValue={inheritedDCUIContent.start.loadingButtonText}
                currentThemingPropertyValue={dcuiContent.start.loadingButtonText}
                pageLevel={pageLevel}
            >
                <InputFormGroup
                    controlId={"dcui-theming-start-page-start-button-loading-text-input"}
                    automationId={"dcui-theming-start-page-start-button-loading-text-input"}
                    label={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.startPage.sections.buttons.inputs.startButtonLoadingText.label}
                    ariaLabel={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.startPage.sections.buttons.inputs.startButtonLoadingText.label}
                    layout={layout}
                    labelWidth={labelWidth}
                    onChange={handleStartButtonLoadingTextChange}
                    value={dcuiContent.start.loadingButtonText || ""}
                    disabled={isDisabled}
                    isRequired={true}
                    afterLabelTooltipText={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.startPage.sections.buttons.inputs.startButtonLoadingText.tooltip}
                    afterLabelIcon={isDisabled ? null : faUndo}
                    afterLabelIconOnClick={handleResetStartButtonLoadingText}
                />
            </ThemingFormGroupWrapper>
            {validationErrors.startButtonLoadingTextError}
        </div>
    );
};